var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.616,
    height: 26,
    viewBox: "0 0 24.616 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16259",
    "data-name": "Group 16259",
    transform: "translate(-4.7 -3)",
    opacity: 0.501
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18966",
    "data-name": "Path 18966",
    d: "M23.781,10.339V4.258A1.262,1.262,0,0,0,22.523,3H5.958A1.262,1.262,0,0,0,4.7,4.258V27.742A1.262,1.262,0,0,0,5.958,29H22.523a1.262,1.262,0,0,0,1.258-1.258V19.019a4.34,4.34,0,0,1,0-8.681ZM9.019,26.819H6.881V24.471H9.019Zm4.194,0H11.074V18.684h2.139Zm4.152,0H15.226V22.877h2.139Zm-3.816-9.855a5.619,5.619,0,0,1,0-11.239v5.619h5.619A5.62,5.62,0,0,1,13.548,16.965Zm8.01,2.935v6.919H19.419V19.9ZM14.89,10V4.342A5.62,5.62,0,0,1,20.51,9.961H14.89Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16257",
    "data-name": "Group 16257",
    transform: "translate(20.3 11.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18967",
    "data-name": "Path 18967",
    d: "M48.861,26.08A3.481,3.481,0,1,1,45.381,22.6,3.472,3.472,0,0,1,48.861,26.08Z",
    transform: "translate(-41.9 -22.598)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16258",
    "data-name": "Group 16258",
    transform: "translate(26.003 16.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18968",
    "data-name": "Path 18968",
    d: "M58.813,38.045l-1.468,1.468L55.5,37.668A4.464,4.464,0,0,0,56.968,36.2Z",
    transform: "translate(-55.5 -36.2)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report_icon.c8c9fbf107e09e91f55f503b39219462.svg";
export { ForwardRef as ReactComponent };